import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


// 获取组织架构信息_树级结构
export const GetOrganizationTreeList = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetOrganizationTreeList", params)
};

// 保存组织架构信息
export const SaveOrganization = (params) => {
	return reqF("post", "/api/sysConfig/Organization/SaveOrganization", params)
};

// 删除组织架构
export const DelOrganization = (params) => {
	return reqF("post", "/api/sysConfig/Organization/DelOrganization", params)
};

// 获取组织架构关联人员列表
export const GetOrganizationUserTreeList = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetOrganizationUserTreeList", params)
};

// 获取组织架构信息_列表
export const GetOrganizationList = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetOrganizationList", params)
};

// 根据配置获取组织架构列表
export const GetOrganizationListByConfig = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetOrganizationListByConfig", params)
};

// 获取组织架构信息详情
export const GetOrganizationInfoDetail = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetOrganizationInfoDetail", params)
};

// 根据配置获取组织架构信息列表
export const GetOrgInfoListByConfig = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetOrgInfoListByConfig", params)
};

